/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PutApiV1TutoraiUsagePersonidLimitMutationRequest,
  PutApiV1TutoraiUsagePersonidLimitMutationResponse,
  PutApiV1TutoraiUsagePersonidLimitPathParams,
  PutApiV1TutoraiUsagePersonidLimit400,
  PutApiV1TutoraiUsagePersonidLimit401,
  PutApiV1TutoraiUsagePersonidLimit500,
} from "../../types/tutorAIUsageController/PutApiV1TutoraiUsagePersonidLimit.ts";

function getPutApiV1TutoraiUsagePersonidLimitUrl(
  personId: PutApiV1TutoraiUsagePersonidLimitPathParams["personId"],
) {
  const res = {
    method: "PUT",
    url: `/api/v1/tutorai/usage/${personId}/limit` as const,
  };
  return res;
}

/**
 * @description Sobrescreve os limites individuais de tokens diário, semanal e mensal do aluno. Use `0` em qualquer limite para remover o valor individual (aplica o padrão global). `enabled = false` desabilita o bloqueio independente dos valores configurados. **(Requer Authorization para autenticação)**
 * @summary Configurar limites de tokens do aluno (Requer Authorization para autenticação)
 * {@link /api/v1/tutorai/usage/:personId/limit}
 */
export async function putApiV1TutoraiUsagePersonidLimit(
  personId: PutApiV1TutoraiUsagePersonidLimitPathParams["personId"],
  data?: PutApiV1TutoraiUsagePersonidLimitMutationRequest,
  config: Partial<
    RequestConfig<PutApiV1TutoraiUsagePersonidLimitMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PutApiV1TutoraiUsagePersonidLimitMutationResponse,
    ResponseErrorConfig<
      | PutApiV1TutoraiUsagePersonidLimit400
      | PutApiV1TutoraiUsagePersonidLimit401
      | PutApiV1TutoraiUsagePersonidLimit500
    >,
    PutApiV1TutoraiUsagePersonidLimitMutationRequest
  >({
    method: "PUT",
    url: getPutApiV1TutoraiUsagePersonidLimitUrl(personId).url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
